<template>
  <div>
    <!-- 列表页面 -->
    <div class="container">
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >系统服务</el-breadcrumb-item>
          <el-breadcrumb-item >系统日志</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
        <div class="table-content">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">日志记录</div>
            </div>

          </div>
          <div class="table-list">
            <el-table
              v-loading='loading'
              border
              style="width: 100%;"
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              :max-height="tableHeight"
              :data="tableData"
              ref="containerTable"
              >
              <el-table-column
                  prop="time"
                  label="时间">
                </el-table-column>
                <el-table-column
                  prop="groupName"
                  label="分组名称">
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="账号名">
                </el-table-column>
                <el-table-column
                  prop="nickname"
                  label="真实姓名">
                </el-table-column>
                <el-table-column
                  prop="action"
                  label="动作">
                </el-table-column>
                <el-table-column
                  prop="ip"
                  label="IP">
                </el-table-column>
                <el-table-column
                  prop="userAgent"
                  label="操作系统">
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="PageSize"
                :total="totalLogAmount"
                :current-page="currentPage"
                @current-change="changeCurrentPage"
                @prev-click="prevClicvPage"
                @next-click="nextClickPage"
                style="margin-top: 15px;margin-left: 15px;margin-bottom: 0px;">
              </el-pagination>
          </div>

        </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        tableData:[],
        tableHeight:0,
        loading:false,

        totalLogAmount:1,//总数量
        totalPageAmount:1 ,//总页数
        PageSize:50,
        currentPage:1,
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;margin-right:5px;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;margin-right:5px;'
      },
      changeCurrentPage(page){
          this.currentPage = page
          this.getData()
          // this.$refs.containerTable.bodyWrapper.scrollTop = 0;
        },
        prevClicvPage(page){
          this.currentPage = page
          this.getData()
          // this.$refs.containerTable.bodyWrapper.scrollTop = 0;
        },
        nextClickPage(page){
          this.currentPage = page
          this.getData()

          // this.$refs.containerTable.bodyWrapper.scrollTop = 0;
        },
        getData(){
          this.loading = true;
          const headers = {
              'Authorization': localStorage.getItem('token')
          }
          const url = '/system/log/list';

          this.$http({
            method:'GET',
            url:url,
            headers:headers,
            params:{'page':this.currentPage,'size':50}
          }).then(res=>{
            this.loading = false;
            if(res.status == 200){//请求成功
            var obj = res.data;
              if(obj.code == 0){
                if(obj.data.logs){
                  this.tableData = obj.data.logs;
                  this.totalLogAmount = obj.data.totalLogAmount;
                  this.totalPageAmount = obj.data.totalPageAmount;
                }
              }else{
                this.$message.error(obj.message);
              }
            }else{
              this.$message.error(res.data.message);
            }
          }).catch(err=>{
            this.loading = false;
            if(!err.response){
              this.$message.error(err.message);
            }else{
              this.$message.error(err.response.data.message);
            }
          })
        },
        sizeFun(){
          this.$nextTick(() => {
            this.tableHeight = window.innerHeight-260 < 300 ? 300 : window.innerHeight-260;
          })
        }
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)
      this.sizeFun()
      this.getData()
    },
    created() {

    },
    beforeDestroy() {

      window.removeEventListener('resize',this.sizeFun)
    }
  }

</script>


<style lang="scss" scoped>
.container {
  margin-top: $header-height;

  .table-content{

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-right: 10px;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-right{
        display: flex;
        flex-direction: row;
        align-items: center;
        // background-color: pink;
        height: 40px;
        width: 90%;
      }
    }

    .table-list{

      .hander{
        cursor: pointer;
        color: #fff;
        background-color: #104C90;
        border: 0px;
      }


      .action-button{
        width: 89px;
        height: 31px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 16px;
        font-size: 14px;

        font-weight: 400;
        color: #00DEFF;
      }

    }

  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/log.vue